import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { warehouseexecApi, type FulfilmentJob } from '../../api/warehouseexec';

export function DispatchDashboardPage() {
  const [jobs, setJobs] = useState<FulfilmentJob[]>([]);
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void warehouseexecApi.listJobs().then(setJobs).catch((e) => setError(String(e)));
  }, []);

  async function createDispatch() {
    const eligible = jobs.filter((j) => j.status === 'dispatch' || j.status === 'packing');
    const ids = (eligible.length ? eligible : jobs).slice(0, 3).map((j) => j.id);
    if (!ids.length) return;
    setMsg('Creating dispatch batch…');
    try {
      const batch = await warehouseexecApi.createDispatch({
        warehouse_id: 'wh-main', carrier: 'DHL', job_ids: ids,
      });
      await warehouseexecApi.completeDispatch(batch.id);
      setMsg(`Dispatch ${batch.id.slice(0, 8)} completed — manifest ${batch.manifest_id?.slice(0, 8) ?? 'n/a'}`);
    } catch (e) {
      setError(String(e));
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/warehouse" className="text-sm text-slate-600 hover:underline">← Warehouse hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Dispatch dashboard</h1>
      <p className="mt-1 text-sm text-slate-600">Create batches, manifests and carrier handover.</p>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <button type="button" onClick={() => void createDispatch()} disabled={!jobs.length}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white disabled:opacity-50">
        Create & complete dispatch batch
      </button>
    </div>
  );
}
